import stored_file_config from "@/components/StoredFile/config";

export default {
  singleLabel: "Réclamation",
  storeNamespace: 'complaint',
  authFeature: 'complaint',
  listRouteName: "ComplaintList",
  detailRouteName: "ComplaintDetail",
  formComponentName: 'ComplaintForm',
  hideActionNewButton: true,
  hideActionEditButton: true,
  hideActionCsvButton: true,
  titleField: 'internal_code',
  sortBy: 'created_at',
  sortDesc: true,
  showExtendedFilters: true,
  fields: [
    {
      name: 'internal_code',
      label: "Numéro",
      type: 'text',
      inList: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'created_at',
      label: "Date",
      type: 'date',
      inForm: false,
      inList: true,
      sortable: true,
      extendedFilter: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'created_at2',
      label: "Date",
      type: 'text',
      inDetail: true,
      inPdfExport: true,
      formatter: (context, value, item) => item && item.created_at ? context.$moment(item.created_at).format("DD-MM-YYYY") : null
    },
    {
      // Déclaration (perte, vol, hors service) ou réclamation : deux parcours distincts
      // en front-office, une seule liste ici — cf. .docs/reclamations/PLAN-REC.
      name: 'request_kind',
      label: "Nature",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      extendedFilter: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? context.$store.getters['complaint/getRequestKind'](value) ? context.$store.getters['complaint/getRequestKind'](value).text : null : null
    },
    {
      name: 'context_label',
      label: "Contexte",
      type: 'text',
      inForm: false,
      inList: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'complaint_type_slug',
      label: "Type",
      type: 'select',
      inList: true,
      sortable: true,
      filterIn: false,
      extendedFilter: true,
      inDetail: true,
      inPdfExport: true,
      formatter: (context, value) => value ? context.$store.getters['complaint/getType'](value) ? context.$store.getters['complaint/getType'](value).text : null : null
    },
    {
      // Filtre seul : origine de la réclamation, via createdBy (NULL = import MCS).
      name: 'from_mcs',
      label: "Origine",
      type: 'select',
      inForm: false,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
      extendedFilter: true,
    },
    {
      name: 'renting',
      label: "Commande",
      type: 'select',
      inList: true,
      inDetail: true,
      detailLink: 'RentingDetail',
      inPdfExport: true,
      formatter: (context, value) => value && value.renting_number ? value.renting_number : null
    },
    {
      name: 'business',
      label: "Affaire",
      type: 'select',
      inList: true,
      inDetail: true,
      inPdfExport: true,
      formatter: (context, value) => value && value.number && value.name ? value.number + " - " + value.name : null
    },
    {
      name: 'transfer',
      label: "Demande de transfert",
      type: 'select',
      inForm: false,
      inList: false,
      inDetail: true,
      detailLink: 'TransferDetail',
      inPdfExport: true,
      formatter: (context, value) => value && value.transfert_number ? value.transfert_number : null
    },
    {
      name: 'business_return',
      label: "Retour",
      type: 'select',
      inForm: false,
      inList: false,
      inDetail: true,
      detailLink: 'BusinessReturnDetail',
      inPdfExport: true,
      formatter: (context, value) => value && value.return_number ? value.return_number : null
    },
    {
      // Renseignée sur une déclaration : date à laquelle la perte, le vol ou la panne
      // a été constaté, distincte de la date de saisie.
      name: 'noticed_at',
      label: "Date de constat",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'reference',
      label: "Référence",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      detailLink: 'ReferenceDetail',
      inPdfExport: true,
      formatter: (context, value) => value && value.product && value.product.name && value.internal_code ? value.internal_code + ' - ' + value.product.name : null
    },
    {
      // REC-001 : une commande de produits vendus ne porte aucune référence unique ; la
      // demande vise alors le produit, et cette colonne prend le relais de « Référence ».
      name: 'product',
      label: "Produit",
      type: 'select',
      inForm: false,
      inList: true,
      inDetail: true,
      detailLink: 'ProductDetail',
      inPdfExport: true,
      formatter: (context, value) => value && value.name ? (value.internal_code ? value.internal_code + ' - ' + value.name : value.name) : null
    },
    {
      name: 'phone_number',
      label: "Numéro de téléphone",
      type: 'text',
      inList: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'message',
      label: "Message",
      type: 'textarea',
      inList: false,
      filterIn: false,
      inDetail: true,
      inPdfExport: true,
    },
    {
      name: 'status',
      label: "Statut",
      type: 'select',
      inList: true,
      sortable: true,
      tabFilter: true,
      key: 'status_slug',
      tabFilterDefaultValue: 'complaint-en-traitement',
      inDetail: true,
      inPdfExport: true,
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      // Personne ESM ayant marqué la demande comme traitée : posée au passage en
      // « Traitée », effacée si la demande y ressort.
      name: 'handled_by',
      label: "Traité par",
      inForm: false,
      inList: false,
      inDetail: true,
      inPdfExport: false,
      formatter: (context, value) => value ? value.firstname + ' ' + value.lastname : null
    },
    {
      name: 'handled_by_pdf',
      label: "Traité par",
      inDetail: false,
      inPdfExport: true,
      formatter: (context, value) => value ? value : null
    },
    {
      // Suivi interne du traitement, invisible du demandeur. Affiché et saisi dans son
      // propre pavé sur la fiche (ComplaintDetail), d'où `inDetail: false` : le détail
      // générique ne sait que lire.
      name: 'comment',
      label: "Remarques",
      type: 'textarea',
      inForm: false,
      inList: false,
      inDetail: false,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'user',
      label: "Demandeur",
      inDetail: true,
      inPdfExport: false,
      displayDetailHtml: true,
      formatter: (context, value) => value ?  value.firstname + ' ' + value.lastname + ' (<a href="mailto:' + value.email + '">' + value.email + '</a>)' : null
    },
    {
      name: 'user_pdf',
      label: "Demandeur",
      inDetail: false,
      inPdfExport: true,
      formatter: (context, value) => value ? value : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inDetail: false,
      inPdfExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inCsvExport: true,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'stored_files',
      label: "Fichiers joints",
      type: 'list',
      icone: 'folder',
      config: stored_file_config,
      fields: ['file']
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/Complaint/config.js